import * as React from "react"

const Proof = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M6.8 2.072h2.4v4.8h2.4v2.4H9.2v4.8H6.8v-4.8H4.4v-2.4h2.4v-4.8Zm-2.4 4.8H2v-2.4h2.4v2.4ZM2 9.272h2.4v2.4H2v-2.4Zm9.6-4.8H14v2.4h-2.4v-2.4Zm0 4.8H14v2.4h-2.4v-2.4Z"
    />
  </svg>
)

export default Proof
